import { IUpdateProjetoImpressaoUseCase } from "../../../presentation/useCases/update/update_projeto_impressao_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * UpdateProjetoImpressaoUseCase
 */

export class UpdateProjetoImpressaoUseCase implements IUpdateProjetoImpressaoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(
    idProjetoImpressao: number,

    idFuncionarioAprovacao: number,
    status: number,
    cor: number,
    quantidade: number,
    statusEmail?: number | null,
    dataAprovacao?: Date | null,
    tamanho?: string,
    observacoesSolicitacao?: string,
    idFornecedor?: number | null,
  ): Promise<void> {
    return await this.repository.updateProjetoImpressao(
      idProjetoImpressao,
      idFuncionarioAprovacao,
      status,
      cor,
      quantidade,
      statusEmail,
      dataAprovacao,
      tamanho,
      observacoesSolicitacao,
      idFornecedor
    );
  }
}
